export enum Roles {
    Admin = 'Admin',
    BlockchainAdmin = 'BlockchainAdmin',
    TreasuryAdmin = 'TreasuryAdmin',
    Owner = 'Owner',
    Member = 'Member',
    Exporter = 'Exporter',
    Importer = 'Importer',
}